import { Link } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const DashboardWaiter = () => {
  return (
    <>
      <SiteTitle title="داشبورد مدیریت" />

      <section className="section kf-services section-bg">
        <div className="container">
          <div className="kf-services-items row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div className="kf-services-item" data-animate="active">
                <div className="image kf-image-hover">
                  <Link to="/waiter/notification">
                    <img src="/assets/images/service1.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-bell" />
                  </div>
                  <h5 className="name">اعلانات</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardWaiter;
